import { AutoPostRationaleKind, type HppdRationale, type Opening, RequestOriginKind } from "../../../utils/models";
import type { FactListItem } from "../../UIToolkit/molecules/FactList";
import { formatAt, leadFact, type OriginCopyContext, ratioRoleLabel } from "./requestOriginCopy";

/** The rows under one cause's sentence: the numbers it rests on (if any), then when it was posted and how far ahead. */
export const openingFacts = (opening: Opening, ctx: OriginCopyContext): FactListItem[] => {
	const { t } = ctx;
	const posted: FactListItem = { label: t("request.origin.fact.posted"), value: formatAt(opening.at, ctx) };
	const lead: FactListItem = { label: t("request.origin.fact.leadTime"), value: leadFact(opening.leadMinutes, ctx) };
	switch (opening.kind) {
		case RequestOriginKind.Agency:
		case RequestOriginKind.AgencyCanceled:
			return [{ label: t("request.origin.fact.agency"), value: opening.agencyName }, posted, lead];
		case RequestOriginKind.AutoPost: {
			const rationale = opening.rationale;
			if (rationale === null) return [posted, lead];
			if (rationale.kind === AutoPostRationaleKind.Hppd) return [{ label: t("request.origin.fact.census"), value: rationale.census }, posted, lead];
			return [
				{ label: t("request.origin.fact.required"), value: `${rationale.required} ${ratioRoleLabel(rationale, ctx)}` },
				{ label: t("request.origin.fact.scheduled"), value: rationale.scheduled },
				{ label: t("request.origin.fact.alreadyPosted"), value: rationale.alreadyPosted },
				lead,
			];
		}
		case RequestOriginKind.CallOff:
		case RequestOriginKind.ReplaceRequest:
		case RequestOriginKind.SwapRequest:
		case RequestOriginKind.TimeOff:
		case RequestOriginKind.TimeOffHris:
		case RequestOriginKind.Deactivation:
		case RequestOriginKind.PostedByPerson:
		case RequestOriginKind.FromRecommendation:
		case RequestOriginKind.PostedByAnnie:
		case RequestOriginKind.CountRaised:
			return [posted, lead];
		default: {
			const unhandled: never = opening;
			throw new Error(`Unhandled origin ${JSON.stringify(unhandled)}`);
		}
	}
};

export const hppdRationaleOf = (opening: Opening): HppdRationale | null =>
	opening.kind === RequestOriginKind.AutoPost && opening.rationale?.kind === AutoPostRationaleKind.Hppd ? opening.rationale : null;
